export default {
  //BACKEND_URL: 'https://a4.clients.hellobuild.co'
  //BACKEND_URL: "http://localhost:8080"
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
};
